module.exports = __webpack_public_path__ + "static/img/1-_07.3d75988.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1-_07.png
// module id = Cyqw
// module chunks = 0